import React from "react";
import { useStyles } from "./errorBoundaryViewStyles";
import { Image, Subtitle1, Text } from "@fluentui/react-components";
import errorImage from "../../../images/error.png";
import { appInsights } from "../../../common";

type ErrorBoundaryViewProps = {
  error?: Error;
  resetErrorBoundary?: () => void;
};

export const ErrorBoundaryView = ({ error }: ErrorBoundaryViewProps) => {
  const styles = useStyles();
  appInsights.trackException(
    {
      exception: error as Error,
    },
    {
      method: "genericErrorBoundary",
    },
  );

  return (
    <div 
      className={styles.errorBoundaryContainer}
      data-testid="errorBoundary"
    >
      <Image 
        className={styles.image} 
        src={errorImage} 
        block={true} 
        fit="cover" 
        alt="Error Image" 
        data-testid="errorImage"
      />
      <Subtitle1 className={styles.textMessage}>
        {"This page isn't working at the moment"}
      </Subtitle1>
      <Text className={styles.subtextMessage}>{error?.message}</Text>
    </div>
  );
};
